"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarrantyType = exports.TypeOfClaim = exports.TaxAccountBalanceType = exports.PropertyVacatedBy = exports.PropertyTransferredBy = exports.PropertySoldBy = exports.PropertyOccupancyStatus = exports.MortgageType = exports.LegalSystemType = exports.LegalActionType = exports.AdditionalSecuritiesHeldByBorrower = void 0;
var AdditionalSecuritiesHeldByBorrower;
(function (AdditionalSecuritiesHeldByBorrower) {
    AdditionalSecuritiesHeldByBorrower[AdditionalSecuritiesHeldByBorrower["ChattelMortgage"] = 1] = "ChattelMortgage";
    AdditionalSecuritiesHeldByBorrower[AdditionalSecuritiesHeldByBorrower["PromissoryNote"] = 2] = "PromissoryNote";
    AdditionalSecuritiesHeldByBorrower[AdditionalSecuritiesHeldByBorrower["Other"] = 3] = "Other";
})(AdditionalSecuritiesHeldByBorrower = exports.AdditionalSecuritiesHeldByBorrower || (exports.AdditionalSecuritiesHeldByBorrower = {}));
var LegalActionType;
(function (LegalActionType) {
    LegalActionType[LegalActionType["Foreclosure"] = 1] = "Foreclosure";
    LegalActionType[LegalActionType["PowerofSale"] = 2] = "PowerofSale";
    LegalActionType[LegalActionType["QuitClaim"] = 3] = "QuitClaim";
    LegalActionType[LegalActionType["WalkAway"] = 4] = "WalkAway";
    LegalActionType[LegalActionType["AssignmentOfMortgage"] = 5] = "AssignmentOfMortgage";
    LegalActionType[LegalActionType["TakingInPaymentByForce"] = 6] = "TakingInPaymentByForce";
    LegalActionType[LegalActionType["TakingInPaymentVoluntary"] = 7] = "TakingInPaymentVoluntary";
    LegalActionType[LegalActionType["SaleByJudicialAuthority"] = 8] = "SaleByJudicialAuthority";
})(LegalActionType = exports.LegalActionType || (exports.LegalActionType = {}));
var LegalSystemType;
(function (LegalSystemType) {
    LegalSystemType[LegalSystemType["CommonLaw"] = 1] = "CommonLaw";
    LegalSystemType[LegalSystemType["CivilLaw"] = 2] = "CivilLaw";
    LegalSystemType[LegalSystemType["Other"] = 3] = "Other";
})(LegalSystemType = exports.LegalSystemType || (exports.LegalSystemType = {}));
var MortgageType;
(function (MortgageType) {
    MortgageType[MortgageType["Standard"] = 1] = "Standard";
    MortgageType[MortgageType["Collateral"] = 2] = "Collateral";
})(MortgageType = exports.MortgageType || (exports.MortgageType = {}));
var PropertyOccupancyStatus;
(function (PropertyOccupancyStatus) {
    PropertyOccupancyStatus[PropertyOccupancyStatus["Vacant"] = 1] = "Vacant";
    PropertyOccupancyStatus[PropertyOccupancyStatus["TenantOccupied"] = 2] = "TenantOccupied";
    PropertyOccupancyStatus[PropertyOccupancyStatus["OccupiedByTheBorrower"] = 3] = "OccupiedByTheBorrower";
    PropertyOccupancyStatus[PropertyOccupancyStatus["OccupiedByARelativeOfTheBorrower"] = 4] = "OccupiedByARelativeOfTheBorrower";
})(PropertyOccupancyStatus = exports.PropertyOccupancyStatus || (exports.PropertyOccupancyStatus = {}));
var PropertySoldBy;
(function (PropertySoldBy) {
    PropertySoldBy[PropertySoldBy["ByApprovedLender"] = 1] = "ByApprovedLender";
    PropertySoldBy[PropertySoldBy["ByBorrower"] = 2] = "ByBorrower";
})(PropertySoldBy = exports.PropertySoldBy || (exports.PropertySoldBy = {}));
var PropertyTransferredBy;
(function (PropertyTransferredBy) {
    PropertyTransferredBy[PropertyTransferredBy["ByApprovedLender"] = 1] = "ByApprovedLender";
    PropertyTransferredBy[PropertyTransferredBy["ByBorrower"] = 2] = "ByBorrower";
    PropertyTransferredBy[PropertyTransferredBy["WithLegalAction"] = 3] = "WithLegalAction";
    PropertyTransferredBy[PropertyTransferredBy["WithoutLegalAction"] = 4] = "WithoutLegalAction";
})(PropertyTransferredBy = exports.PropertyTransferredBy || (exports.PropertyTransferredBy = {}));
var PropertyVacatedBy;
(function (PropertyVacatedBy) {
    PropertyVacatedBy[PropertyVacatedBy["Borrower"] = 1] = "Borrower";
    PropertyVacatedBy[PropertyVacatedBy["Tenant"] = 2] = "Tenant";
    PropertyVacatedBy[PropertyVacatedBy["RelativeOfBorrower"] = 3] = "RelativeOfBorrower";
})(PropertyVacatedBy = exports.PropertyVacatedBy || (exports.PropertyVacatedBy = {}));
var TaxAccountBalanceType;
(function (TaxAccountBalanceType) {
    TaxAccountBalanceType[TaxAccountBalanceType["Deficit"] = 1] = "Deficit";
    TaxAccountBalanceType[TaxAccountBalanceType["Surplus"] = 2] = "Surplus";
})(TaxAccountBalanceType = exports.TaxAccountBalanceType || (exports.TaxAccountBalanceType = {}));
var TypeOfClaim;
(function (TypeOfClaim) {
    TypeOfClaim[TypeOfClaim["TitleTransfer"] = 1] = "TitleTransfer";
    TypeOfClaim[TypeOfClaim["AssignmentOfMortgage"] = 2] = "AssignmentOfMortgage";
    TypeOfClaim[TypeOfClaim["DeficiencySale"] = 3] = "DeficiencySale";
    TypeOfClaim[TypeOfClaim["EnhancedClaimService"] = 4] = "EnhancedClaimService";
    TypeOfClaim[TypeOfClaim["WalkAway"] = 5] = "WalkAway";
})(TypeOfClaim = exports.TypeOfClaim || (exports.TypeOfClaim = {}));
var WarrantyType;
(function (WarrantyType) {
    WarrantyType[WarrantyType["ApprovedLendersCorporateWarranty"] = 1] = "ApprovedLendersCorporateWarranty";
    WarrantyType[WarrantyType["ApprovedLendersSolicitorsCertificateToCmhc"] = 2] = "ApprovedLendersSolicitorsCertificateToCmhc";
    WarrantyType[WarrantyType["TitleInsurance"] = 3] = "TitleInsurance";
})(WarrantyType = exports.WarrantyType || (exports.WarrantyType = {}));
